import { useSelector } from 'react-redux'
import { dataAnsStorageView } from '$logic/data-and-storage/storage'

export function useAutoDownload() {
  return useSelector(state => dataAnsStorageView(state)?.autoDownload)
}

export function useAutoPlayAudio() {
  return useSelector(
    state => !(dataAnsStorageView(state)?.autoPlayAudio === false),
  )
}
